export default "__VITE_ASSET__0e7166df__"